export * from './ng2-smart-table.module';
export { DefaultEditor } from './components/cell/cell-editors/default-editor';
export { Cell } from './lib/data-set/cell';
export { LocalDataSource } from './lib/data-source/local/local.data-source';
export { ServerDataSource } from './lib/data-source/server/server.data-source';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ng2-smart-table/index.js
// module id = ../../../../ng2-smart-table/index.js
// module chunks = 37